import { getLocalePrefix } from '@monoimin/intl';

import { pickFirstImageFromGalleryField } from '../images/pickFirstImageFromGalleryField';

import type { ISbStoryData } from 'storyblok-js-client';

import type { Locales, EventStoryblok } from '@monoimin/sb-types';

export const createPropsForEventSliderCard = (
  blok: ISbStoryData<EventStoryblok>,
  locale: Locales
) => {
  const { content, slug } = blok;

  const { heading, image, date, previewHeading } = content;

  const localePrefix = getLocalePrefix(locale);

  const preparedImage = pickFirstImageFromGalleryField(image);

  return {
    title: previewHeading || heading,
    imageUrl: preparedImage?.src,
    url: `${localePrefix}/events/${slug}`,
    caption: date,
  };
};

export default createPropsForEventSliderCard;
